module.exports = __webpack_public_path__ + "img/circles.1e567154.svg";